import React from "react";
import PropTypes from "prop-types";
import FilterDropdown from "../../components/ui-components/FilterDropdown";

const BASES = [
  { key: "incurred_amortized", label: "Incurred" },
  { key: "token_amortized", label: "By usage" },
  { key: "invoiced", label: "Invoiced" },
];

// BasisSelect — cost-recognition basis picker. A "Basis:"-prefixed dropdown so it
// shares the same control grammar (and height) as the Breakdown selector next to
// it, rather than a heavier segmented control. The API-equivalent (shadow) toggle
// lives separately (row-3 far right) — see ApiEquivalentToggle. Disabled under an
// owner/perspective filter, where the scoped tables carry no shadow/billing_mode.
export default function BasisSelect({ value, onChange, disabled }) {
  return (
    <FilterDropdown
      ariaLabel="Basis"
      prefix="Basis:"
      value={value}
      onChange={onChange}
      disabled={disabled}
      minWidth={150}
      height={32}
      options={BASES.map((b) => ({ value: b.key, label: b.label }))}
    />
  );
}

BasisSelect.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

// ApiEquivalentToggle — the shadow/AI-equivalent overlay checkbox, split out so it
// can sit at the far right of the row-3 controls, apart from the basis segmented.
export function ApiEquivalentToggle({ showShadow, onShowShadowChange, disabled }) {
  return (
    <label className={`flex items-center gap-1.5 text-[13px] ${disabled ? "text-text-3 opacity-50" : "text-text-2"}`}>
      <input type="checkbox" checked={showShadow} disabled={disabled} onChange={(e) => onShowShadowChange(e.target.checked)} />
      Include API-equivalent cost
    </label>
  );
}

ApiEquivalentToggle.propTypes = {
  showShadow: PropTypes.bool.isRequired,
  onShowShadowChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
